import {
  IconButtonAsButton,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@newfront-insurance/core-ui/v2';

import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
import { IconSidebar } from '../icons';

interface ToggleSidebarProps {
  className?: string;
}

/**
 * Button component for toggling sidebar visibility.
 * Uses chat overlay context to manage sidebar state.
 */
export function ToggleSidebar({ className }: ToggleSidebarProps) {
  const { isSidebarOpen, setIsSidebarOpen } = useChatOverlayContext();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <IconButtonAsButton
            onClick={(e) => {
              e.stopPropagation();
              setIsSidebarOpen(!isSidebarOpen);
            }}
            className={className}
          >
            <IconSidebar />
          </IconButtonAsButton>
        </TooltipTrigger>
        <TooltipContent className="z-[1400]">Toggle Sidebar</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
